import { render, staticRenderFns } from "./editModal.vue?vue&type=template&id=8fc0c4dc&scoped=true&"
import script from "./editModal.vue?vue&type=script&lang=ts&"
export * from "./editModal.vue?vue&type=script&lang=ts&"
import style0 from "./editModal.vue?vue&type=style&index=0&id=8fc0c4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc0c4dc",
  null
  
)

export default component.exports